import React, { Component } from 'react';
import qs from 'querystringify';

import { TopicItem } from './components/TopicItem/index';
import { ModalFinish } from './components/ModalFinish/index';
import { QuestionItem } from './components/QuestionItem/index';
import { ProgressBar } from './components/ProgressBar/index';
import {
  getQuestionsByTopicId,
  getTopicsByModuleIdAndCategoryAndLevel,
  updateAnsweredQuestions,
  getAssessment,
  getCompanyLevel
} from '../../services/index';

import { Button } from '../../components/Button/index';
import { Trans, i18nMark, withI18n } from 'lingui-react';
import ReactLoading from 'react-loading';
import './question.css';

class Question extends Component {
  constructor(props) {
    super(props);
    this.state = {
      questions: [],
      topics: [],
      modal: false,
      isOverlap: false,
      currentCategory: 'O',
      answeredQuestions: 0,
      heightTopicItems: 0,
      answeredQuestionsForAllCategory: [],
      questionsForAllCategory: [],
      answeredQuestionsForAllCategoryCompleted: false,
      isQuestionCommentOpen: false
    };
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  }

  handleSave = (e, questionId, valueContent) => {
    const questionWithComment = this.state.questions.map(q => {
      let question = q;
      if (q._id === questionId) question['comment'] = valueContent;
      return question;
    })
    this.setState({ questions: questionWithComment });
  }

  componentDidMount() {
    document.title = this.props.i18n._(i18nMark('Security Selfie'));
    window.addEventListener('resize', this.resize);
    const category = qs.parse(this.props.location.search).category;
    const assessmentId = qs.parse(this.props.location.search).assessmentId;
    if (category === "technology") {
      this.setState({
        currentCategory: 'T'
      })
    }
    this.setState({ loading: true });

    getAssessment(assessmentId)
      .then(assessment => {
        getCompanyLevel(assessment.companyId)
          .then(companyLevel => {
            getTopicsByModuleIdAndCategoryAndLevel(assessment.moduleId, category, companyLevel) // FIXME: too many questions in "questionIds"
              .then(result => {
                let topics = result;
                this.setState({
                  topics: topics,
                });
                this.setState({
                  heightTopicItems: this.refs.leftPaneContent.clientHeight + 55 + 84
                })

                const topicId = qs.parse(this.props.location.search).topicId || topics[0]._id;
                this.getQuestionsByTopicIdAndAssessmentAndLevel(topicId, assessment, companyLevel)
                  .then(q => {
                    this.setState({ questions: q, activeIndex: topicId });
                    if (assessment.answers) {
                      let answeredQuestions = assessment.answers.filter(a => {
                        return topics
                          .reduce((preVal, elem) => {
                            return [...preVal, ...elem.questionIds];
                          }, []).indexOf(a.questionId) > -1;
                      }).filter(a => a.answer);
                      this.setState({
                        answeredQuestions: answeredQuestions.length,
                        answeredQuestionsForAllCategory: assessment.answers,
                        questionsForAllCategory: assessment.questionsForAllCategory
                      });
                      if (assessment.answers.length === assessment.questionsForAllCategory.length) {
                        this.setState({ answeredQuestionsForAllCategoryCompleted: true })
                      }
                      topics = topics.map(t => {
                        const answeredQuestionsPerTopic = assessment.answers.filter(a => {
                          return t.questionIds.indexOf(a.questionId) > -1;
                        }).filter(a => a.answer);
                        t.answerCompleted = t.questionIds.length === answeredQuestionsPerTopic.length;
                        return t;
                      });
                      this.setState({ topics: topics });
                      this.setState({ loading: false });
                    } else {
                      this.setState({ loading: false });
                    }
                  });
              })
          })
      })
      .catch(err => {
        this.setState({ loading: false });
        console.log('getAssessment error '.err);
      });
    // calculate answeredQuestions

  }

  resize = () => {
    this.setState({
      isMobile: window.innerWidth <= 576,
      isOverlap: window.innerHeight < this.state.heightTopicItems
    })
  }

  getQuestionsByTopicIdAndAssessmentAndLevel = (topicId, assessment, level) => {
    return new Promise((resolve, reject) => {
      getQuestionsByTopicId(topicId)
        .then(questions => {
          let result = questions.filter(q => (q.level <= level));
          if (assessment.answers) {
            result.forEach((q, i) => {
              const ans = assessment.answers.find(a => a.questionId === q._id);
              if (ans) {
                result[i]['answer'] = ans.answer;
                result[i]['comment'] = ans.comment;
              }
            });
          }
          resolve(result);
        })
        .catch(err => reject(err));
    });
  };

  calculateProgressbar() {
    const totalQuestions = this.state.topics.reduce((preVal, elem) => {
      return preVal + elem.questionIds.length;  // FIXME: too many questionIds, only need questions for the current level
    }, 0);
    return {
      percent: this.state.answeredQuestions / totalQuestions * 60,
      totalQuestions: totalQuestions,
      answeredQuestions: this.state.answeredQuestions
    };
  }

  handleClickTopicItem = (topicId, topicIndex) => {
    const category = qs.parse(this.props.location.search).category;
    const assessmentId = qs.parse(this.props.location.search).assessmentId;
    this.setState({ loading: true });
    this.handleUpdateAnsweredQuestions().then(() => {
      this.setState({ loading: false });
      this.props.history.push('/question?assessmentId=' + assessmentId + '&category=' + category +
        '&topicId=' + topicId + '&topicIndex=' + topicIndex
      );
    }).catch(err => console.log('handleUpdateAnsweredQuestions error: ', err));
  };

  handleClickAnswerQuestion = e => {
    const questions = this.state.questions.map(q => {
      let question = q;
      if (q._id === e.target.id) question['answer'] = e.target.name;
      return question;
    });
    this.setState({ questions: questions });
    let answered = questions.filter(q => q.answer).length;
    if (answered + this.state.answeredQuestionsForAllCategory.length === this.state.questionsForAllCategory.length
      || this.state.answeredQuestionsForAllCategory.length === this.state.questionsForAllCategory.length)
      this.setState({ answeredQuestionsForAllCategoryCompleted: true })
  };

  handleClickNextTopic = () => {
    const category = qs.parse(this.props.location.search).category;
    const assessmentId = qs.parse(this.props.location.search).assessmentId;
    const nextTopic = this.getNextTopic();
    if (nextTopic && nextTopic.topic) {
      this.setState({ loading: true });
      this.handleUpdateAnsweredQuestions()
        .then(() => {
          this.setState({ loading: false });
          this.props.history.push(
            '/question?assessmentId=' +
            assessmentId +
            '&category=' +
            category +
            '&topicId=' +
            nextTopic.topic._id +
            '&topicIndex=' +
            nextTopic.topicIndex
          );
        })
        .catch(err => console.log('updateAnsweredQuestions error: ', err));
    }
  };

  getNextTopic = () => {
    const currentTopicId =
      qs.parse(this.props.location.search).topicId || this.state.topics[0]._id;
    let nextTopic = null;
    this.state.topics.forEach((t, index) => {
      if (t._id === currentTopicId)
        nextTopic = {
          topic: this.state.topics[index + 1],
          topicIndex: index + 2
        };
    });
    return nextTopic;
  };

  handleClickNextCategory = () => {
    const assessmentId = qs.parse(this.props.location.search).assessmentId;
    this.setState({ loading: true });
    this.handleUpdateAnsweredQuestions().then(() => {
      this.setState({ loading: false });
      this.props.history.push(
        '/question?assessmentId=' + assessmentId + '&category=technology'
      );
    }).catch(err => console.log('updateAnsweredQuestions error: ', err));
  };

  handleClickPreviousTopic = () => {
    const category = qs.parse(this.props.location.search).category;
    const assessmentId = qs.parse(this.props.location.search).assessmentId;
    const preTopic = this.getPreviousTopic();
    if (preTopic && preTopic.topic) {
      this.setState({ loading: true });
      this.handleUpdateAnsweredQuestions().then(() => {
        this.setState({ loading: false });
        this.props.history.push(
          '/question?assessmentId=' +
          assessmentId +
          '&category=' +
          category +
          '&topicId=' +
          preTopic.topic._id +
          '&topicIndex=' +
          preTopic.topicIndex
        );
      }).catch(err => console.log('updateAnsweredQuestions error: ', err));
    }
  };

  getPreviousTopic = () => {
    const currentTopicId =
      qs.parse(this.props.location.search).topicId || this.state.topics[0]._id;
    let preTopic = null;
    this.state.topics.forEach((t, index) => {
      if (t._id === currentTopicId)
        preTopic = { topic: this.state.topics[index - 1], topicIndex: index };
    });
    return preTopic;
  };

  handleClickPreviousCategory = () => {
    const assessmentId = qs.parse(this.props.location.search).assessmentId;
    this.setState({ loading: true });
    this.handleUpdateAnsweredQuestions().then(() => {
      this.setState({ loading: false });
      this.props.history.push(
        '/question?assessmentId=' + assessmentId + '&category=organization'
      );
    }).catch(err => console.log('updateAnsweredQuestions error: ', err));
  };

  handleFinishAnswer = () => {
    if (this.state.answeredQuestionsForAllCategoryCompleted) {
      const assessmentId = qs.parse(this.props.location.search).assessmentId;
      this.setState({ loading: true });
      this.handleUpdateAnsweredQuestions().then(() => {
        this.setState({ loading: false });
        this.props.history.push('assessment-report?assessmentId=' + assessmentId);
      }).catch(err => console.log('updateAnsweredQuestions error: ', err));
    } else {
      this.toggle();
    }
  };

  handleUpdateAnsweredQuestions = () => {
    const answeredQuestions = this.state.questions;
    const assessmentId = qs.parse(this.props.location.search).assessmentId;
    return updateAnsweredQuestions(assessmentId, answeredQuestions.filter(a => a.answer !== null && a.answer !== '' && a.answer !== undefined));
  };

  render() {
    let topicsList = null;
    let questionList = null;
    const categoryName = qs.parse(this.props.location.search).category;
    let topicIndex = qs.parse(this.props.location.search).topicIndex;
    if (!topicIndex) {
      topicIndex = '1';
    }
    let str = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    if (this.state.topics != null) {
      topicsList = this.state.topics.map((element, topicIndex) => {
        return (
          <TopicItem
            key={topicIndex}
            topicId={element._id}
            index={topicIndex + 1}
            itemDetails={element.name_en}
            description={element.description_en}
            checked={element.answerCompleted}
            charIndex={str.charAt(topicIndex)}
            onClick={this.handleClickTopicItem}
            isActive={this.state.activeIndex === element._id}
          />
        );
      });
    }
    if (this.state.questions != null) {
      questionList = this.state.questions.map((element, index) => {
        return (
          <QuestionItem
            key={index}
            no={index + 1}
            categoryCode={this.state.currentCategory}
            explanation={element.explanation_en}
            topicIndex={str.charAt(topicIndex - 1)}
            questionId={element._id}
            handleClick={this.handleClickAnswerQuestion}
            handleSave={this.handleSave}
            comment={element.comment}
            questionContent={element.question_en}
            answer={element.answer}
          />
        );
      });
    }

    return (
      <div>
        {
          <div className="question-container">
            <ModalFinish
              modal={this.state.modal}
              toggle={this.toggle} />
            <div className="container-fluid">
              <div className="row">
                <div className="left-pane">
                  <div className="left-pane-title">
                    <h5>{categoryName === 'organization' ? <Trans id='Category: Organization' /> : <Trans id='Category: Technology' />}</h5>
                    <div className="answer-pane">
                      <span className="answer-label"><Trans id="Answered" />:&nbsp;</span>
                      <ProgressBar data={this.calculateProgressbar()} />
                    </div>
                  </div>
                  <div ref="leftPaneContent" className={this.state.isOverlap ? "left-pane-content-scroll" : "left-pane-content"}>
                    {topicsList}
                  </div>
                </div>
                {
                  this.state.topics[topicIndex - 1] ? <div className="col-12 d-flex flex-row align-items-center justify-content-around no-padding header-topic">
                    <div className="col-12">
                      <p className="title-topic">{str.charAt(topicIndex - 1)}. {this.state.topics[topicIndex - 1].name}</p>
                    </div>
                  </div> : ''
                }

                <div className="col-12 col-lg-7 col-md-8 right-pane">
                  {/* Repeat Question Item */}
                  <div className="question-list">{questionList}</div>

                </div>
                <div className="col-12 col-lg-7 col-md-8 no-padding right-pane">
                  {qs.parse(this.props.location.search).category ===
                    'organization' ? (
                    <div className="col-12 no-padding justify-content-around justify-content-sm-end d-flex flex-row right-pane-button">
                      {topicIndex === '1' ? (
                        <Button
                          styleButton="question-next-button"
                          text={this.state.isMobile ? this.props.i18n._(i18nMark('Next')) : this.props.i18n._(i18nMark('Next Topic'))}
                          onClick={this.handleClickNextTopic}
                        />
                      ) : topicIndex === this.state.topics.length.toString() ? (
                        [
                          <Button
                            key="1"
                            styleButton="question-previous-button"
                            text={this.state.isMobile ? this.props.i18n._(i18nMark('Previous')) : this.props.i18n._(i18nMark('Previous Topic'))}
                            onClick={this.handleClickPreviousTopic}
                          />,
                          <Button
                            key="2"
                            styleButton="question-next-button"
                            text={this.state.isMobile ? this.props.i18n._(i18nMark('Next')) : this.props.i18n._(i18nMark('Next Category'))}
                            onClick={this.handleClickNextCategory}
                          />
                        ]
                      ) : (
                        [
                          <Button
                            key="1"
                            styleButton="question-previous-button"
                            text={this.state.isMobile ? this.props.i18n._(i18nMark('Previous')) : this.props.i18n._(i18nMark('Previous Topic'))}
                            onClick={this.handleClickPreviousTopic}
                          />,
                          <Button
                            key="2"
                            styleButton="question-next-button"
                            text={this.state.isMobile ? this.props.i18n._(i18nMark('Next')) : this.props.i18n._(i18nMark('Next Topic'))}
                            onClick={this.handleClickNextTopic}
                          />
                        ]
                      )}
                    </div>
                  ) : (
                    <div className="col-12 no-padding justify-content-around justify-content-sm-end d-flex flex-row right-pane-button">
                      {topicIndex === '1'
                        ? [
                          <Button
                            key="1"
                            styleButton="question-previous-button"
                            text={this.state.isMobile ? this.props.i18n._(i18nMark('Previous')) : this.props.i18n._(i18nMark('Previous Category'))}
                            onClick={this.handleClickPreviousCategory}
                          />,
                          <Button
                            key="2"
                            styleButton="question-next-button"
                            text={this.state.isMobile ? this.props.i18n._(i18nMark('Next')) : this.props.i18n._(i18nMark('Next Topic'))}
                            onClick={this.handleClickNextTopic}
                          />
                        ]
                        : topicIndex === this.state.topics.length.toString()
                          ? [
                            <Button
                              key="1"
                              styleButton="question-previous-button"
                              text={this.state.isMobile ? this.props.i18n._(i18nMark('Previous')) : this.props.i18n._(i18nMark('Previous Category'))}
                              onClick={this.handleClickPreviousTopic}
                            />,

                            <Button
                              key="2"
                              styleButton={'question-next-button'}
                              text={this.props.i18n._(i18nMark('Finish'))}
                              onClick={this.handleFinishAnswer}
                            />
                          ]
                          : [
                            <Button
                              key="1"
                              styleButton="question-previous-button"
                              text={this.state.isMobile ? this.props.i18n._(i18nMark('Previous')) : this.props.i18n._(i18nMark('Previous Topic'))}
                              onClick={this.handleClickPreviousTopic}
                            />,
                            <Button
                              key="2"
                              styleButton="question-next-button"
                              text={this.state.isMobile ? this.props.i18n._(i18nMark('Next')) : this.props.i18n._(i18nMark('Next Topic'))}
                              onClick={this.handleClickNextTopic}
                            />
                          ]}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        }
        <div className={this.state.loading ? 'loading-overlay active' : 'loading-overlay'}>
          <ReactLoading type="spin" color="#444" className="loading-icon" />
        </div>
      </div>
    );
  }
}
export default withI18n({ withRef: true })(Question);



// WEBPACK FOOTER //
// ./src/screens/Question/Question.js